/* This reducer is used for fetching surgery details */

import {
    GET_SURGERY_DETAILS,
    GET_SURGERY_DETAILS_SUCCESS,
    GET_SURGERY_DETAILS_FAILURE,
} from '../actions';

const initialState = {
    surgeryData: {},
    loading: false,
    statusCode: 0,
    statusMessage: '',
    // myCaseRef: ''
};

const surgeryDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_SURGERY_DETAILS:
            return {
                ...state,
                surgeryData: {},
                loading: true,
            };
        case GET_SURGERY_DETAILS_SUCCESS:
            return {
                ...state,
                surgeryData: {
                    ...state.surgeryData,
                    ...action.payload.surgeryData,
                },
                // myCaseRef: action.payload.myCaseRef,
                statusCode: action.payload.statusCode,
                statusMessage: action.payload.statusMessage,
                loading: false,
            };
        case GET_SURGERY_DETAILS_FAILURE:
            return {
                ...state,
                validatedProducts: [],
                statusCode: action.statusCode,
                statusMessage: action.statusMessage,
                loading: false,
            };

        default: {
            return { ...state };
        }
    }
};

export default surgeryDetailsReducer;
